import { useEffect, useRef, useState } from 'react';
import MembershipEdit from './MembershipEdit';
import WebUniversal, { getService, WebUniversalProps } from '../../system/WebUniversal';
import { Button, Space, Tooltip } from 'antd';
import MembershipTransactionDetails from './MembershipTransactionDetails';
import MembershipPointsDetails from './MembershipPointsDetails';
import MembershipForShopBalance from './MembershipForShopBalance';
import MembershipBalancePointLock from './MembershipBalancePointLock';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import { LoggerTypes } from '../../../bmCommonLibrary/bmDeclareTypes';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import BindPhysicalCardToMembership from './BindPhysicalCardToMembership';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'membership';
    const [modalVisibleMembershipTransactionDetails, setModalVisibleMembershipTransactionDetails] = useState<boolean>(false);
    const [modalVisibleMembershipPointsDetails, setModalVisibleModalVisibleMembershipPointsDetails] = useState<boolean>(false);
    const [modalVisibleMembershipForShopBalance, setModalVisibleMembershipForShopBalance] = useState<boolean>(false);
    const [modalVisibleMembershipBalancePointLock, setModalVisibleMembershipBalancePointLock] = useState<boolean>(false);
    const [modalVisibleBindPhysicalCardToMembership, setModalVisibleBindPhysicalCardToMembership] = useState<boolean>(false);
    const [membershipRechargeBillsData, setMembershipRechargeBillsData] = useState<any>();
    const [membershipTypeData, setMembershipTypeData] = useState<any>();
    const [membershipBalancePointLockData, setMembershipBalancePointLockData] = useState<any>();
    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();
    const [membershipStatusData, setMembershipStatusData] = useState<any>();
    const [membershipModeData, setMembershipModeData] = useState<any>();
    const [shopData, setShopData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
            setSendPageData(ref.current.sendPageData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'membershipType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipTypeData([{ id: 'ALLITEM', typeName: '所有类型' }, ...res.data]);
                }
            })
        fetchApi.GET(getService('bm'),
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'membershipStatus@membershipMode',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { membershipStatus, membershipMode } = res.data;
                    setMembershipStatusData([{ id: 'ALLITEM', name: '所有状态' }, ...membershipStatus]);
                    setMembershipModeData([{ id: 'ALLITEM', name: '所有模式' }, ...membershipMode]);
                }
            })
        fetchApi.GET(getService('bm'),
            {
                query: {
                    apiId: 'shop',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setShopData([{ id: 'ALLITEM', shopName: '所有店铺' }, ...res.data]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '姓名',
            dataIndex: 'membershipInfo',
            render: (val: any) => val?.membershipName
        },
        {
            title: '联系电话',
            dataIndex: 'membershipInfo',
            render: (val: any) => val?.contactNumber
        },
        {
            title: '余额',
            dataIndex: 'balance',
            sorter: true
        },
        {
            title: '赠送',
            dataIndex: 'gifts',
            sorter: true
        },
        {
            title: '积分',
            dataIndex: 'points',
            sorter: true
        },
        {
            title: '锁定',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Tooltip placement="topLeft" title={'锁定会员余额积分'}>
                            <Button type='primary' onClick={() => {
                                setMembershipBalancePointLockData({
                                    membershipId: val
                                })
                                setModalVisibleMembershipBalancePointLock(true);
                            }}>{'锁定'}</Button>
                        </Tooltip>
                    </Space>
                </>
            )
        },
        {
            title: '店铺余额',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='dashed' onClick={() => {
                            setMembershipRechargeBillsData({
                                membershipId: val
                            })
                            setModalVisibleMembershipForShopBalance(true);
                        }}>{'店铺余额'}</Button>
                    </Space>
                </>
            )
        },
        {
            title: '类型',
            dataIndex: 'membershipType',
            render: (val: any) => val?.typeName
        },
        {
            title: '模式',
            dataIndex: 'membershipMode',
            render: (val: any) => val?.name
        },
        {
            title: '交易明细',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='primary' onClick={() => {
                            setMembershipRechargeBillsData({
                                membershipId: val
                            })
                            setModalVisibleMembershipTransactionDetails(true);
                        }}>{'交易明细'}</Button>
                    </Space>
                </>
            )
        },
        {
            title: '积分明细',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='primary' onClick={() => {
                            setMembershipRechargeBillsData({
                                membershipId: val
                            })
                            setModalVisibleModalVisibleMembershipPointsDetails(true);
                        }}>{'积分明细'}</Button>
                    </Space>
                </>
            )
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '会员',
        apiId,
        columns,
        editOptions: {
            Editor: MembershipEdit
        },
        serviceId: 'business',
        expandableOptions: {
            useSystemTree: true,
            // isTree: true,
            subColumns: columns,
            // subDataName: 'children',
            // isSameMainDisplayOptions: true,
        },
        displayOptions: {
            showAdd: false,
            loggerProps: {
                showSingleLogger: true,
                LoggerTypes,
                loggerTypeId: 'MEMBERSHIP'
            }
        }
    };

    return (
        <> <Space>
            <CustomSelect
                apiId={apiId}
                sendKeyId='membershipTypeId'
                getListData={membershipTypeData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName="typeName"
            />
            <CustomSelect
                apiId={apiId}
                sendKeyId='membershipStatusId'
                getListData={membershipStatusData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
            />
            <CustomSelect
                apiId={apiId}
                sendKeyId='membershipModeId'
                getListData={membershipModeData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
            />
            <CustomSelect
                apiId={apiId}
                sendKeyId='shopId'
                getListData={shopData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName='shopName'
            />
            <Button type='primary' onClick={() => {
                setModalVisibleBindPhysicalCardToMembership(true);
            }}>绑定会员实体卡</Button>
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalVisibleMembershipTransactionDetails ?
                (<MembershipTransactionDetails
                    closeModal={() => setModalVisibleMembershipTransactionDetails(false)}
                    data={membershipRechargeBillsData} />)
                : null}
            {modalVisibleMembershipPointsDetails ?
                (<MembershipPointsDetails
                    closeModal={() => setModalVisibleModalVisibleMembershipPointsDetails(false)}
                    data={membershipRechargeBillsData} />)
                : null}
            {modalVisibleMembershipForShopBalance ?
                (<MembershipForShopBalance
                    closeModal={() => setModalVisibleMembershipForShopBalance(false)}
                    data={membershipRechargeBillsData} />)
                : null}
            {modalVisibleMembershipBalancePointLock ?
                (<MembershipBalancePointLock
                    closeModal={() => setModalVisibleMembershipBalancePointLock(false)}
                    data={membershipBalancePointLockData} />)
                : null}
            {modalVisibleBindPhysicalCardToMembership ?
                (<BindPhysicalCardToMembership
                    closeModal={(result?: { success?: boolean }) => {
                        setModalVisibleBindPhysicalCardToMembership(false);
                        if (result?.success) fetchData?.();
                    }}

                />)
                : null}

        </>
    )
}

export default WebComponent;
